<template>
    <div class="stats">
        <div v-for="size in getDefaultPizzaSizes" :key="size.id">
            <strong> {{ size.name }} </strong> $ {{ size.price }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'pizzaSize',
    computed: {
    ...mapGetters(['getDefaultPizzaSizes'])
  },
}
</script>

<style>

</style>